
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kids/kids-shows/[showName]/[showId]/[episodeName_seasonNo]/[episodeId]",
      function () {
        return require("private-next-pages/kids/kids-shows/[showName]/[showId]/[episodeName_seasonNo]/[episodeId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kids/kids-shows/[showName]/[showId]/[episodeName_seasonNo]/[episodeId]"])
      });
    }
  